import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import MDButton from 'components/MDButton';
import MDInput from "components/MDInput";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Oval } from 'react-loader-spinner';
import Select from "react-select";
import * as service from '../../../services/service';

function User() {
    const [state, setState] = useState({ firstname: '', lastname: '', emailid: '', mobileno: '', password: '', councilregno: '' });
    const [data, setData] = useState([]);
    const [designationId, setDesignationId] = useState('');
    const [designationData, setDesignationData] = useState([]);
    const [civilIDCData, setCivilIDCData] = useState([]);
    const [civilCEOData, setCivilCEOData] = useState([]);
    const [civilSEOData, setCivilSEOData] = useState([]);
    const [civilDivisionData, setCivilDivisionData] = useState([]);
    const [civilIDCId, setCivilIDCId] = useState('');
    const [civilCEOId, setCivilCEOId] = useState('');
    const [civilSEOId, setCivilSEOId] = useState('');
    const [civilDivisionId, setCivilDivisionId] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [userLevel, setUserLevel] = useState('');
    const [userType, setUserType] = useState('');
    const [active, setActive] = useState('');
    const userLevelData = [{ label: "Civil IDC", value: "Civil IDC" }, { label: "Civil CEO", value: "Civil CEO" },
    { label: "Civil SEO", value: "Civil SEO" }, { label: "Civil Division", value: "Civil Division" }];
    const activeData = [{ label: "Active", value: true }, { label: "Inactive", value: false }];
    const userTypeData = [{ label: "User", value: "User" }, { label: "Advocate", value: "Advocate" },
    { label: "Legal Advisor", value: "Legal Advisor" }];
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };

    const getDesignations = () => {
        fetch(
            service.DESIGNATION_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.designationId, label: item.designation }));
                setDesignationData(data2);
            });
    };

    const getCivilIDCs = () => {
        fetch(
            service.CIVILIDC_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.civilIDCId, label: item.civilIDC }));
                setCivilIDCData(data2);
            });
    };

    const getCivilCEOs = (id) => {
        fetch(
            service.GET_CIVILCEO_BY_IDC_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CivilIDCId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.civilCEOId, label: item.civilCEO }));
                setCivilCEOData(data2);
            });
    };

    const getCivilSEOs = (id) => {
        fetch(
            service.GET_CIVILSEO_BY_CEO_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CivilCEOId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.civilSEOId, label: item.civilSEO }));
                setCivilSEOData(data2);
            });
    };

    const getCivilDivisions = (id) => {
        fetch(
            service.GET_CIVIL_DIVISION_BY_SEO_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CivilSEOId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.civilDivisionId, label: item.civilDivision }));
                setCivilDivisionData(data2);
            });
    };

    const getDetails = () => {
        const errs = {};
        fetch(
            service.USERS_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(result => {
                setData(result);
            })
            .catch(err => {
                if (err) {
                    errs[".invalid"] = err;
                    setErrors(err);
                };
            });
    };

    const getDetailsById = (id) => {
        setLoading(true);
        const errs = {};
        fetch(
            service.GET_USER_BY_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    UserId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result.message.messageType === 'Success') {
                    setState({
                        ...state, firstname: result.firstName, lastname: result.lastName, emailid: result.emailId, mobileno: result.mobileNo,
                        password: result.password, councilregno: result.councilRegNo
                    });

                    const type = ({ value: result.userType, label: result.userType });
                    setUserType(type);
                    const lev = ({ value: result.userLevel, label: result.userLevel });
                    setUserLevel(lev);
                    const idcData = ({ value: result.civilIDCId, label: result.civilIDC });
                    setCivilIDCId(idcData);
                    getCivilCEOs(idcData.value);
                    const ceData = ({ value: result.civilCEOId, label: result.civilCEO });
                    setCivilCEOId(ceData);
                    getCivilSEOs(ceData.value);
                    const seData = ({ value: result.civilSEOId, label: result.civilSEO });
                    setCivilSEOId(seData);
                    getCivilDivisions(seData.value);
                    const divData = ({ value: result.civilDivisionId, label: result.civilDivision });
                    setCivilDivisionId(divData);

                    const des = ({ value: result.designationId, label: result.designation });
                    setDesignationId(des);
                    const ac = ({ value: result.isActive, label: result.isActive ? 'Active' : 'Inactive' });
                    setActive(ac);
                }
                else {
                    errs[".invalid"] = result.message.message;
                    setErrors(errs);
                }
            });
        setLoading(false);
    };
    const handleEdit = (id) => {
        getDetailsById(id);
        localStorage.setItem("ID", JSON.stringify(id));
    }

    useEffect(() => {
        setLoading(true);
        getDesignations();
        getCivilIDCs();
        getDetails();

        const ac = ({ value: true, label: "Active" });
        setActive(ac);

        const tp = ({ value: "User", label: "User" });
        setUserType(tp);
        setLoading(false);
    }, []);

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!state.firstname) {
            isValid = false;
            errs[".firstname"] = "Please enter first name";
        }
        if (!state.lastname) {
            isValid = false;
            errs[".lastname"] = "Please enter last name";
        }
        if (userType.value === "User" && !designationId) {
            isValid = false;
            errs[".designation"] = "Please select designation";
        }
        if (!userType) {
            isValid = false;
            errs[".userType"] = "Please select user type";
        }
        if (userType.value === "User" && !userLevel) {
            isValid = false;
            errs[".userLevel"] = "Please select user level";
        }
        if (userLevel.value === 'Civil IDC' && !civilIDCId) {
            isValid = false;
            errs[".civilIDCId"] = "Please select Civil IDC";
        }
        if (userLevel.value === 'Civil CEO' && !civilCEOId) {
            isValid = false;
            errs[".civilCEOId"] = "Please select Civil CEO";
        }
        if (userLevel.value === 'Civil SEO' && !civilSEOId) {
            isValid = false;
            errs[".civilSEOId"] = "Please select Civil SEO";
        }
        if (userLevel.value === 'Civil Division' && !civilDivisionId) {
            isValid = false;
            errs[".civilDivisionId"] = "Please select Civil Division";
        }
        if (!state.emailid) {
            isValid = false;
            errs[".emailId"] = "Please enter emailId";
        }
        if (!state.mobileno) {
            isValid = false;
            errs[".mobileno"] = "Please enter mobile no.";
        }
        setErrors(errs);
        return isValid;
    }

    const changeHandler = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    };
    const CivilIDCChangeHandler = (ev) => {
        setCivilIDCId(ev);
        getCivilCEOs(ev.value);
    }

    const CivilCEOChangeHandler = (ev) => {
        setCivilCEOId(ev);
        getCivilSEOs(ev.value);
    }
    const CivilSEOChangeHandler = (ev) => {
        setCivilSEOId(ev);
        setCivilDivisionData([]);
        getCivilDivisions(ev.value);
    }
    const CivilDivisionChangeHandler = (ev) => {
        setCivilDivisionId(ev);
    }

    const DesignationChangeHandler = (ev) => {
        setDesignationId(ev);
    }
    const UserLevelChangeHandler = (ev) => {
        setUserLevel(ev);
    }
    const ActiveChangeHandler = (ev) => {
        setActive(ev);
    }
    const UserTypeChangeHandler = (ev) => {
        setUserType(ev);
    }
    const clearHandler = () => {
        localStorage.setItem('ID', null);
        setState({ ...state, firstname: '', lastname: '', emailid: '', mobileno: '', password: '', councilregno: '' });
        const lv = ({ value: '', label: "Select User Level" });
        setUserLevel(lv);
        const tp = ({ value: '', label: "Select User Type" });
        setUserType(tp);
        const idc = ({ value: null, label: "Select Civil IDC" });
        setCivilIDCId(idc);
        const ceo = ({ value: null, label: "Select Civil CEO" });
        setCivilCEOId(ceo);
        const seo = ({ value: null, label: "Select Civil SEO" });
        setCivilSEOId(seo);
        const div = ({ value: null, label: "Select Civil Division" });
        setCivilDivisionId(div);
        const des = ({ value: '', label: "Select Designation" });
        setDesignationId(des);
    }

    const submitHandler = e => {
        e.preventDefault();
        const errs = {};
        setLoading(true);
        if (validate()) {
            fetch(
                service.ADD_UPDATE_USER,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        UserId: JSON.parse(localStorage.getItem('ID')) !== null ? JSON.parse(localStorage.getItem('ID')) : 0,
                        FirstName: state.firstname,
                        LastName: state.lastname,
                        MobileNo: state.mobileno,
                        EmailId: state.emailid,
                        Password: state.password ? state.password : state.mobileno, // `${state.firstname}@123`,
                        DesignationId: designationId ? designationId.value : 0,
                        UserLevel: userLevel.value,
                        UserType: userType.value,
                        CivilIDCId: civilIDCId ? civilIDCId.value : 0,
                        CivilCEOId: civilCEOId ? civilCEOId.value : 0,
                        CivilSEOId: civilSEOId ? civilSEOId.value : 0,
                        CivilDivisionId: civilDivisionId ? civilDivisionId.value : 0,
                        CouncilRegNo: state.councilregno,
                        IsActive: active.value,
                        AddedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                        UpdatedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        // eslint-disable-next-line
                        alert(result.message);
                        localStorage.setItem('ID', null);
                        window.location.reload();
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                    }
                    else {
                        errs[".invalid"] = result.message;
                        setErrors(errs);
                    }
                });
        }
        setLoading(false);
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    User Details
                                </MDTypography>
                            </MDBox>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>
                                                <Select
                                                    name="userType"
                                                    options={userTypeData}
                                                    value={userType}
                                                    onChange={UserTypeChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".userType"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell width="45%">
                                                <MDInput label="First Name" fullWidth value={state.firstname || ''}
                                                    name="firstname"
                                                    onChange={changeHandler}
                                                    id="firstname"
                                                    required />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".firstname"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <MDInput label="Last Name" fullWidth value={state.lastname || ''}
                                                    name="lastname"
                                                    onChange={changeHandler}
                                                    id="lastname"
                                                    required />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".lastname"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <MDInput label="Email" fullWidth value={state.emailid || ''}
                                                    name="emailid"
                                                    type="email"
                                                    onChange={changeHandler}
                                                    id="emailid"
                                                    required
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".emailId"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <MDInput label="Mobile No" fullWidth value={state.mobileno || ''}
                                                    name="mobileno"
                                                    onChange={changeHandler}
                                                    id="mobileno"
                                                    required
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".mobileno"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <Select
                                                    options={designationData}
                                                    name="designation"
                                                    value={designationId}
                                                    onChange={DesignationChangeHandler}
                                                    placeholder="Select Designation"
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={userType.value !== "User"}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".designation"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <Select
                                                    options={userLevelData}
                                                    name="userLevel"
                                                    value={userLevel}
                                                    onChange={UserLevelChangeHandler}
                                                    placeholder="Select User Level"
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={userType.value !== "User"}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".userLevel"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <Select
                                                    name="Civil IDC"
                                                    options={civilIDCData} placeholder="Select Civil IDC"
                                                    value={civilIDCId}
                                                    onChange={CivilIDCChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={userType.value !== "User"}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".civilIDCId"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <Select
                                                    name="Civil CEO"
                                                    options={civilCEOData} placeholder="Select Civil CEO"
                                                    value={civilCEOId}
                                                    onChange={CivilCEOChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={userType.value !== "User" || userLevel.value === "Civil IDC"}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".civilCEOId"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <Select
                                                    name="Civil SEO"
                                                    options={civilSEOData} placeholder="Select Civil SEO"
                                                    value={civilSEOId}
                                                    onChange={CivilSEOChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={userType.value !== "User" || userLevel.value === "Civil CEO"}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".civilSEOId"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <Select
                                                    name="Civil Division"
                                                    options={civilDivisionData} placeholder="Select Civil Division"
                                                    value={civilDivisionId}
                                                    onChange={CivilDivisionChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={userType.value !== "User" || userLevel.value === "Civil SEO"}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".civilDivisionId"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <MDInput label="Council Reg No" fullWidth value={state.councilregno || ''}
                                                    name="councilregno"
                                                    onChange={changeHandler}
                                                    id="councilregno"
                                                    required
                                                    disabled={userType.value !== "Advocate"}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".councilregno"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <Select
                                                    name="Active"
                                                    options={activeData}
                                                    value={active}
                                                    onChange={ActiveChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".active"]}</div>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                                <MDBox mt={4} mb={1} textAlign="center">
                                    {loading ? <Oval
                                        heigth="20"
                                        width="20"
                                        color='grey'
                                        ariaLabel='loading'
                                    /> :
                                        <div>
                                            <MDButton color="info" onClick={submitHandler}>
                                                SAVE
                                            </MDButton>&nbsp;&nbsp;&nbsp;&nbsp;
                                            <MDButton color="info" onClick={clearHandler}>
                                                CLEAR
                                            </MDButton>
                                        </div>
                                    }
                                    {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                </MDBox>

                            </Card>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '95%', alignSelf: 'center', }}>
                                        <Table aria-label="simple table">

                                            <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                <TableCell style={{ fontWeight: 'bold' }}>Name</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Email</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Mobile No.</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Designation</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>User Level</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Civil IDC</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Civil CEO</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Civil SEO</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Civil Division</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Active</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
                                            </TableRow>

                                            <TableBody>
                                                {data.map((row) => (
                                                    <TableRow
                                                        key={row.userId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell>{row.firstName} {row.lastName}</TableCell>
                                                        <TableCell>{row.emailId}</TableCell>
                                                        <TableCell>{row.mobileNo}</TableCell>
                                                        <TableCell>{row.designation}</TableCell>
                                                        <TableCell>{row.userLevel}</TableCell>
                                                        <TableCell>{row.civilIDC}</TableCell>
                                                        <TableCell>{row.civilCEO}</TableCell>
                                                        <TableCell>{row.civilSEO}</TableCell>
                                                        <TableCell>{row.civilDivision}</TableCell>
                                                        <TableCell>{row.isActive ? 'Active' : 'Inactive'}</TableCell>
                                                        <TableCell><MDButton onClick={() => handleEdit(row.userId)}>Edit</MDButton></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                }
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
                <Footer />
            </div>
        </DashboardLayout>
    );
}
export default User;